import { Component, inject, OnDestroy, Signal } from '@angular/core';
import {
  RegistrationForTheSewageTreatmentPlantRegisterForm
} from './forms/registration-for-the-sewage-treatment-plant-register.form';
import { stages } from '../../registration-for-the-sewage-treatment-plant-register.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { NgxMaskDirective } from 'ngx-mask';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';

@Component({
  selector: 'app-registration-for-the-sewage-treatment-plant-register-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective,
    DatePickerComponent
  ],
  providers: [RegistrationForTheSewageTreatmentPlantRegisterForm],
  templateUrl: './registration-for-the-sewage-treatment-plant-register-section.component.html'
})
export class RegistrationForTheSewageTreatmentPlantRegisterSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public form: RegistrationForTheSewageTreatmentPlantRegisterForm = inject(RegistrationForTheSewageTreatmentPlantRegisterForm);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
